query leadIds($input: LeadIdsInput!) {
  leadIds(input: $input) {
    leadIds
  }
}
